/**
 * Централизованные переменные стилей (цвета, размеры).
 * Использовать везде вместо захардкоженных значений.
 */

// ─── Фоны (тёмная тема) ─────────────────────────────────────────────────────
export const backgroundPrimary = "#2B2D39";
export const backgroundPrimaryRgb = "rgb(43, 45, 57)";
export const backgroundPrimaryRgba = "rgba(43, 45, 57, 1)";

export const backgroundSecondary = "#333443";
export const backgroundSecondaryRgb = "rgb(51, 52, 67)";
export const backgroundSecondaryRgba = "rgba(51, 52, 67, 0.5)";

export const backgroundTertiary = "#414250";
export const backgroundDark = "#2A2D39";
export const backgroundCard = "#262732";
export const backgroundTableHeader = "#19191b";
export const backgroundListItem = "#353C5D";
export const backgroundListItemHover = "#393a48";

// ─── Границы ────────────────────────────────────────────────────────────────
export const borderPrimary = "#454650";
export const borderSecondary = "#3A3B47";
export const borderTertiary = "#393A48";
export const borderLight = "#6b6b6b";
export const borderOverlay = "#E1E6EC";

// ─── Текст ──────────────────────────────────────────────────────────────────
export const textPrimary = "#ffffff";
export const textPrimaryShort = "#fff";
export const textSecondary = "#E9E9EA";
export const textMuted = "#6F7080";
export const textDisabled = "#7F818D";
export const textGray = "#7B7B7B";
export const textInactive = "#8E8E8E";
export const textDark = "#000";
export const textLabel = "#363636";

// ─── Акценты (кнопки, ссылки, бренд) ─────────────────────────────────────────
export const accentBlue = "#5F76F2";
export const accentBlueBright = "#4378FF";
export const accentBlueLink = "#4C89FE";
export const accentBlueButton = "#3C6CE6";
export const accentBlueRgba = "rgba(76, 137, 254, 0.2)";

export const accentYellow = "#FADF55"; // Атон, алмаз
export const accentRed = "#FF624D"; // вводы/выводы, ошибки
export const accentRedError = "#d94141";
export const accentRedErrorLight = "#ff6b6b";
export const accentGreen = "#5ff261";
export const accentGreenSuccess = "#36b2ab";
export const accentGreenSuccessDark = "#2da382";
export const accentGreenTrust = "#288c5f";
export const accentGreenDark = "#236b4f";

// ─── Палитра звёзд (воронка) — дублирует FunnelConstants.STARS_COLORS ───────
export const starColors = {
    star1: "#6F7080",
    star2: "#5F76F2",
    star3: "#E479C0",
    star4: "#EF5E70",
    star5: "#EF785E",
    star6: "#FADF55", // алмаз
} as const;

// ─── Доп. цвета для графиков и форм ─────────────────────────────────────────
export const chartScrollbarGrip = "#333443";
export const chartScrollbarTrack = "#2A2D39";
export const chartTooltipBg = "#000";
export const chartTooltipText = "#fff";
export const chartGridLine = "#fff";
export const chartDefaultGray = "#6F7080";

// Палитра для выбора цвета (RefuseReasons, Resources)
export const palettePicker = [
    "#9253E9",
    "#C96BE0",
    "#E479C0",
    "#EF5E70",
    "#FF624D",
    "#EF785E",
    "#FFA429",
    "#F8D522",
    "#92CF88",
    "#6FCA9E",
    "#36B2AB",
    "#5DD1D9",
    "#2CC0FF",
    "#2CA6FF",
    "#4378FF",
    "#5F76F2",
] as const;

export const colorPickerDefault = "#9253E9";

// ─── Размеры (общие) ────────────────────────────────────────────────────────
export const borderRadius = "8px";
export const borderWidth = "1px";
export const overlayBackdrop = "rgba(0, 0, 0, 0.7)";
export const shadowDefault = "rgba(0, 0, 0, 0.24)";
export const shadowMedium = "rgba(0, 0, 0, 0.3)";
export const shadowLight = "rgba(0, 0, 0, 0.2)";

/** Объект для использования в theme или styled-components */
export const designTokens = {
    background: {
        primary: backgroundPrimary,
        primaryRgb: backgroundPrimaryRgb,
        secondary: backgroundSecondary,
        tertiary: backgroundTertiary,
        dark: backgroundDark,
        card: backgroundCard,
        tableHeader: backgroundTableHeader,
        listItem: backgroundListItem,
        listItemHover: backgroundListItemHover,
    },
    border: {
        primary: borderPrimary,
        secondary: borderSecondary,
        tertiary: borderTertiary,
        light: borderLight,
        overlay: borderOverlay,
    },
    text: {
        primary: textPrimary,
        secondary: textSecondary,
        muted: textMuted,
        disabled: textDisabled,
        gray: textGray,
        inactive: textInactive,
        dark: textDark,
        label: textLabel,
    },
    accent: {
        blue: accentBlue,
        blueBright: accentBlueBright,
        blueLink: accentBlueLink,
        blueButton: accentBlueButton,
        blueRgba: accentBlueRgba,
        yellow: accentYellow,
        red: accentRed,
        redError: accentRedError,
        redErrorLight: accentRedErrorLight,
        green: accentGreen,
        greenSuccess: accentGreenSuccess,
        greenSuccessDark: accentGreenSuccessDark,
        greenTrust: accentGreenTrust,
        greenDark: accentGreenDark,
    },
    starColors,
    chart: {
        scrollbarGrip: chartScrollbarGrip,
        scrollbarTrack: chartScrollbarTrack,
        tooltipBg: chartTooltipBg,
        tooltipText: chartTooltipText,
        gridLine: chartGridLine,
        defaultGray: chartDefaultGray,
    },
    palettePicker,
    colorPickerDefault,
    borderRadius,
    borderWidth,
    overlayBackdrop,
    shadow: {
        default: shadowDefault,
        medium: shadowMedium,
        light: shadowLight,
    },
} as const;

export default designTokens;
